import React from 'react'
import { createUrl } from '../../../../../Routing/urls'
import {
  PlayerCardStyle,
  PlayerProfileCon,
  PlayerInfoCon,
  PlayerHeader,
  PlayerNameYearsCon,
  PlayerDetails,
  PlayerMeta,
  PlayerTeam,
  PlayerNameAccoladeCon,
  PlayerAccoladeCon,
} from '../styles'
import { PlayerDataGQL } from '../../../../../Api'
import { getTeamIc } from '../../../../../Utils'
import { getAccoladeCount } from '../../../../../Utils/Players/playersHelper'
import { colors } from '../../../../../Components/consts'
import { StarFilled } from '../../../../../Components/Icons'
import { Lk } from '../../../../../Components/Links/Lk'
import { Img } from '../../../../../Components/Image/Img'
import { PLL_IMAGES } from '../../../../../Config/config'

type PlayerProps = {
  playerInfo: PlayerDataGQL | null
  league: 'PLL' | 'WLL'
  showAccolade?: boolean
  condensed?: boolean
}

export const PlayerItem: React.FC<React.PropsWithChildren<PlayerProps>> = ({
  playerInfo,
  league,
  showAccolade = false,
  condensed = false,
}) => {
  if (!playerInfo) return null

  const getStatsUrl = () => {
    if (league === 'WLL') return '#'
    return createUrl('player', {
      firstName: playerInfo?.firstName,
      lastName: playerInfo?.lastName,
      slugName: playerInfo?.slug,
      tab: 'stats',
    })
  }

  const getPlayerAccoladeCount = (): number | null => {
    const count: number = getAccoladeCount('All-Star', playerInfo)
    return count > 0 ? count : null
  }

  const accoladeCount = getPlayerAccoladeCount()

  return (
    <PlayerCardStyle condensed={condensed}>
      <Lk link={getStatsUrl()} alt={`${playerInfo.name} Profile`}>
        <PlayerInfoCon>
          <PlayerHeader>
            <PlayerMeta>
              {playerInfo?.jerseyNum !== null && (
                <span>#{playerInfo.jerseyNum}</span>
              )}
            </PlayerMeta>
            <PlayerProfileCon>
              <Img
                src={playerInfo.profileUrl || PLL_IMAGES.defaultProfile}
                alt={`${playerInfo.name} Profile`}
              />
            </PlayerProfileCon>
            <PlayerMeta>
              <span>{playerInfo.position}</span>
            </PlayerMeta>
          </PlayerHeader>
          <PlayerDetails>
            <PlayerNameAccoladeCon>
              {playerInfo.currentTeam?.fullName && (
                <PlayerTeam>
                  <Img
                    src={getTeamIc(playerInfo.currentTeam.fullName)}
                    alt={playerInfo.currentTeam.fullName}
                  />
                </PlayerTeam>
              )}
              <PlayerNameYearsCon>
                <h3>{playerInfo.name}</h3>
              </PlayerNameYearsCon>
              {showAccolade && accoladeCount && (
                <PlayerAccoladeCon>
                  <StarFilled fill={colors.yellow} width={12} />
                  <span>{accoladeCount}X</span>
                </PlayerAccoladeCon>
              )}
            </PlayerNameAccoladeCon>
          </PlayerDetails>
        </PlayerInfoCon>
      </Lk>
    </PlayerCardStyle>
  )
}
